export default function ExLastContact({ addedTime, contactMethod, contactedBy, savedBy }) {
    if (contactMethod)
        return (
        <>
            <span>Last contact {contactedBy}: {contactMethod} at </span>
            <input
            type="datetime-local"
            className="prjdetails-date-without-icon"
            value={new Date(addedTime).toISOString().slice(0, 16)}
            readOnly
            />
        </>
        );
    else
        return (
    <>
        <span>Saved By {savedBy}: </span>
            <input
            type="datetime-local"
            className="prjdetails-date-without-icon"
            value={new Date(addedTime).toISOString().slice(0, 16)}
            readOnly
            />
    </>
    )
  }